// CAUTION: This file is used in several parts of the application.

import CloudflareTurnstile from '../../../../library/clxProductNet/assets/js/modules/turnstile/cloudflareTurnstile';

//watchlist image upload
// @ts-ignore
function readURL(input, targetobj) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function (e) {
            // @ts-ignore
            $('#' + targetobj).attr('src', e.target.result);
        };

        reader.readAsDataURL(input.files[0]);
    }
}

/**
 * Shows a no entry sign on a link or button
 * @param $element The jQuery link or button
 * @param milliSeconds Time in milliseconds the sign should be visible
 * @returns undefined
 */
// @ts-ignore
function showNoEntrySignForNSeconds($element, milliSeconds) {
    // @ts-ignore
    var $span = $element.find('span');

    // @ts-ignore
    var oldText = $span.text();
    var oldWidth = $element.css('width');

    $element.toggleClass('changed');
    $element.css('width', oldWidth);

    // @ts-ignore
    $span.fadeOut('slow', function () {
        // @ts-ignore
        $span.empty().html('&#x1F6AB;'); // "no entry" sign
    });

    // @ts-ignore
    $span.fadeIn('fast', function () {
        // @ts-ignore
        $span.delay(milliSeconds).fadeOut('fast', function () {
            // @ts-ignore
            $span.empty().text(oldText);
            // @ts-ignore
            $span.fadeIn('slow', function () {
                $element.toggleClass('changed');
            });
        });
    });
}

/**
 * call for adding articles to shoppingbaskes / watchlist
 * @param $link The HTML element which triggered the action
 * @param entries The artgroesse / amount combinations to add to the basket
 * @param location The controller::action to call
 * @returns Promise
 */
// @ts-ignore
function addArticlesToWatchlistOrBasket($link, entries, location) {
    // make sure the button doesn't get smaller because of the shorter text we will add
    var oldWidth = $link.css('width');
    $link.css('width', oldWidth);

    /* make sure the arrow besides the "check-mark" is not visible when button clicked*/
    $link.removeClass('arrow');
    $link.addClass('active');

    //add artgroesseids to url
    // @ts-ignore
    $.each(entries, function (index, element) {
        if (!index) {
            location += '?artgroesseids[]=' + element['artgroesseid'];
        } else {
            location += '&artgroesseids[]=' + element['artgroesseid'];
        }

        location += '&amountids[]=' + element['amount'];
    });

    // @ts-ignore
    var ajaxPromise = $.ajax({
        dataType: 'json',
        url: location,
        // @ts-ignore
        success: function (data) {
            if ('ok' == data.message) {
                var type = '';
                if (location.search('shoppingbasket') != -1) {
                    type = 'shoppingbasket';
                } else if (location.search('watchlist') != -1) {
                    type = 'watchlist';
                }
                // @ts-ignore
                updateNumberOfSkusInHeader(type);
            } else {
                //TODO: wann koennen Artikel nicht in den Warenkorb / die Merkliste gelegt werden?
                alert('Artikel konnte nicht in den Warenkorb gelegt werden');
            }

            //TODO: clear all input fields?
        },
    });

    // @ts-ignore
    jQuery.when(ajaxPromise).done(function () {
        setTimeout(function () {
            /* show the arrow again */
            $link.addClass('arrow');
            $link.removeClass('active');
        }, 2000);
    });

    return ajaxPromise;
}

// @ts-ignore
$(document).ready(function () {
    // @ts-ignore
    $('.img_upload').on('change', function () {
        // @ts-ignore
        let targetobj = 'tgt-' + $(this).data('itemid');
        // @ts-ignore
        readURL(this, targetobj);
    });

    //Inplace editing of values in watchlist
    // @ts-ignore
    $('.watchlist_index form').on('focusout', '.input_holder input', function (event) {
        // @ts-ignore
        var watchlistitemsizeid = $(this)
            .attr('name')
            .match(/amount\[(\d+)\]/);

        // No update if not amount field
        if (watchlistitemsizeid == null) {
            return;
        }

        // Don`t submit the complete form when pressing enter in an amount input field.
        // Just update the current itemsize
        if (event.keyCode == 13) {
            event.preventDefault();
        }

        // @ts-ignore
        var amount = $(this).val().trim();

        //sanitize amount
        // @ts-ignore
        var error = validateNumber(amount);
        // @ts-ignore
        if (errorEnum.no_error !== error) {
            return;
        }

        // @ts-ignore
        var url = $(this).closest('form').prop('action');
        var location = url + 'edit/watchlistitemsizeid/' + watchlistitemsizeid[1] + '/amount/' + Number(amount) + '/';

        // @ts-ignore
        $.ajax({
            dataType: 'json',
            url: location,
            // @ts-ignore
            success: function (data) {
                if ('ok' == data.message) {
                    // @ts-ignore
                    updateNumberOfSkusInHeader('watchlist');
                } else {
                    //alert('Fail');
                }
            },
        });
    });

    //article detail - item to basket and neukundenanfrage (article detail)
    // @ts-ignore
    $('.details_main').on('click', 'form#art-detail-to-basket button.button', function (event) {
        event.preventDefault();

        // @ts-ignore
        var $button = $(this);
        var $btn_disabled = $button.attr('disabled');

        // For some browsers, `attr` is undefined; for others, `attr` is false. Check for both.
        if (typeof $btn_disabled !== typeof undefined && $btn_disabled !== false) {
            return;
        }

        // @ts-ignore
        var $form = $('form#art-detail-to-basket');

        var $mengeInput = $form.find('input#q_num').first();
        var menge = $mengeInput.val().trim();

        //sanitize menge
        $mengeInput.unwrap('span.field_with_errors'); //remove previous set errors

        // @ts-ignore
        var error = validateNumber(menge);
        // @ts-ignore
        if (errorEnum.no_error !== error) {
            // @ts-ignore
            if (errorEnum.zero == error) {
                //if 0, just clear field
                $mengeInput.val('');
            } else {
                //else mark error field
                $mengeInput.wrap('<span class="field_with_errors"></span>');
                showNoEntrySignForNSeconds($button, 3000);
            }

            return;
        }

        var colorSelect = document.querySelector('sl-select#colors');
        var sizeSelect = document.querySelector('sl-select#groesse_bestand');

        // @ts-ignore
        var artfarbeId = colorSelect.value;
        // @ts-ignore
        var artgroesseId = sizeSelect.value;

        // @ts-ignore
        var farbenId = colorSelect.querySelector('sl-option[value="' + artfarbeId + '"]').dataset.colorid;

        var entries = [];
        entries.push({artgroesseid: artgroesseId, artfarbeid: artfarbeId, amount: Number(menge)});

        var location = $button.data('url');
        location += 'farbenid/' + farbenId + '/artfarbeid/' + artfarbeId + '/';

        var promiseBasket = addArticlesToWatchlistOrBasket($button, entries, location);

        promiseBasket.done(function () {
            // @ts-ignore
            articleDetailApi.reloadPriceDependents();
        });
    });

    let watchlistFormTurnstile: CloudflareTurnstile | null;
    let turnstileContainer = document.querySelector<HTMLDivElement>('.turnstile_container .turnstile');
    if (turnstileContainer !== null) {
        watchlistFormTurnstile = new CloudflareTurnstile('.turnstile_container .turnstile', '.query_submit .button');
        watchlistFormTurnstile.renderWidget();
    }

    //article detail - item to basket and neukundenanfrage ('related articles' slider, 'get-the-look' and 'alle farben und bestaende')
    // @ts-ignore
    $('section#content_part').on('click', 'a.animatebasket', function (event) {
        event.preventDefault();

        // if CF is not ready, the user shouldn't be able to click the button
        if (turnstileContainer !== null) {
            if (!watchlistFormTurnstile) {
                return false;
            }

            const token = watchlistFormTurnstile.getToken();
            if (!token) {
                return false;
            }
        }

        // @ts-ignore
        let $link = $(this);
        // @ts-ignore
        if ($link.hasClass('changed')) {
            //disable click when animation is running
            return;
        }

        //get all mengen inputs from table
        // @ts-ignore
        var $table = $link.prev('table');
        // @ts-ignore
        var entries = getEntries($table);

        //if any of the values is invalid, show warnings and don't proceed
        {
            // @ts-ignore
            let $messageContainer = $link.next('.error-messages');
            // @ts-ignore
            if ($messageContainer.length) {
                //there is only a message container in the related articles slider, colors list is missing it
                //clear previous messages
                // @ts-ignore
                $messageContainer.find('p').css('display', 'none');
            }

            if (entries.errors.length) {
                var hasError = false;
                // @ts-ignore
                $.each(entries.errors, function (key, value) {
                    // @ts-ignore
                    if (errorEnum.zero == value['message']) {
                        //just clear field
                        value['element'].val('');
                    } else {
                        value['element'].wrap('<span class="field_with_errors"></span>');
                        hasError = true;
                    }
                });

                if (hasError) {
                    // @ts-ignore
                    if ($messageContainer.length) {
                        //there is only a message container in the related articles slider, colors list is missing it
                        // @ts-ignore
                        $messageContainer.find('p').css('display', 'block');
                    }

                    // @ts-ignore
                    showNoEntrySignForNSeconds($link, 3000);
                }

                return;
            }
        }

        //we need at least one valid entry, otherwise don't proceed
        if (!entries.entries.length) {
            return;
        }

        // @ts-ignore
        var location = $link.attr('href');

        //only show popup if adding to shopping basket, not to watchlist
        // @ts-ignore
        var showPopup = $link.data('popup');

        if (showPopup) {
            // @ts-ignore
            popups.open('popup_recalculating_prices');
        }

        // @ts-ignore
        var promiseBasket = addArticlesToWatchlistOrBasket($link, entries.entries, location);
        promiseBasket.fail(function () {
            if (showPopup) {
                // @ts-ignore
                popups.close();
            }
        });

        if (showPopup) {
            promiseBasket.done(function () {
                // @ts-ignore
                if ($link.parents('.related').length) {
                    // @ts-ignore
                    articleDetailApi.reloadRelatedArticles();
                }

                // @ts-ignore
                articleDetailApi.reloadPriceDependents().then(function () {
                    // @ts-ignore
                    popups.close();
                });
            });
        }
    });

    /**
     * Get all the artgroesse/amount from the inputs in a table
     * @TODO: remove error status for inputs here?
     * @param $table
     * @returns array
     */
    // @ts-ignore
    function getEntries($table) {
        // @ts-ignore
        var errors = [];
        // @ts-ignore
        var entries = [];

        $table.find('input').each(function () {
            //remove previous set error css
            // @ts-ignore
            $(this).unwrap('span.field_with_errors');

            // @ts-ignore
            var value = $(this).val().trim();
            // @ts-ignore
            var error = validateNumber(value);

            switch (error) {
                // @ts-ignore
                case errorEnum.no_error:
                    //all seems ok, add artgroesse and number to basket
                    // @ts-ignore
                    var artgroesse = $(this).closest('tr').data('artgroesseid');
                    // @ts-ignore
                    var artfarbeid = $(this).closest('tr').data('artfarbeid');

                    entries.push({artgroesseid: artgroesse, artfarbeid: artfarbeid, amount: Number(value)});
                    break;
                // @ts-ignore
                case errorEnum.empty:
                    return true; //same as continue;
                default:
                    // @ts-ignore
                    errors.push({message: error, element: $(this)});
                    break;
            }
        });

        // @ts-ignore
        return {errors: errors, entries: entries};
    }
});
